import type { PlatformOverview } from '@grc/types';

type Point = PlatformOverview['charts']['signupsPerWeek'][number];

/** A compact 12-bucket bar chart for platform trend data (no chart lib). */
export function MiniBars({ data }: { data: Point[] }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  const first = data[0]?.label ?? '';
  const last = data[data.length - 1]?.label ?? '';
  return (
    <div>
      <div className="mini-bars" role="img" aria-label={`Trend over ${data.length} weeks`}>
        {data.map((d) => (
          <div
            key={d.label}
            className="bar"
            title={`Week of ${d.label}: ${d.value}`}
            style={{ height: `${Math.max(2, Math.round((d.value / max) * 100))}%` }}
          />
        ))}
      </div>
      <div className="mini-bars-axis">
        <span>{first}</span>
        <span>{last}</span>
      </div>
    </div>
  );
}
